module.exports = __webpack_public_path__ + "static/media/san_diego_sunset.0bd8d033.jpeg";